module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": _vm.dark
    }
  }, [_c('vue-progress-bar'), _vm._v(" "), (!_vm.loggedIn) ? [_c('router-view', {
    attrs: {
      "dark": _vm.dark
    }
  })] : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? [_c('v-navigation-drawer', {
    class: _vm.dark ? '' : 'blue lighten-5',
    attrs: {
      "dark": _vm.dark,
      "width": "250",
      "light": "",
      "mini-variant": _vm.mini,
      "app": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/assets/img/logo.png"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.account_info.nick_name))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "right": "",
      "offset-y": "",
      "origin": "bottom right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.userMenus), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "value": "true",
        "to": item.link,
        "router": ""
      }
    }, [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "router": ""
      },
      on: {
        "click": function($event) {
          _vm.clickMenu(item)
        }
      }
    }, [_c('v-list-tile-action', {
      staticClass: "pr-1 pl-2 mr-1"
    }, [_c('v-icon', {
      class: _vm.activeMenuItem.includes(item.title) ? 'blue--text' : '',
      attrs: {
        "title": item.title,
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      class: _vm.activeMenuItem.includes(item.title) ? 'blue--text' : ''
    }, [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), (_vm.showFilters()) ? _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": true,
      "transition": "v-scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-3 mb-6 right-input",
    attrs: {
      "slot": "activator",
      "label": "От:",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromRu),
      callback: function($$v) {
        _vm.fromRu = $$v
      },
      expression: "fromRu"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autoclose": "",
      "locale": 'ru-RU'
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  })], 1) : _vm._e(), _vm._v("\n         "), (_vm.showFilters()) ? _c('v-text-field', {
    staticClass: "mt-3 mb-6 right-input",
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "type": "time"
    },
    model: {
      value: (_vm.fromTime),
      callback: function($$v) {
        _vm.fromTime = $$v
      },
      expression: "fromTime"
    }
  }) : _vm._e(), _vm._v("\n            \n        "), (_vm.showFilters()) ? _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": true,
      "transition": "v-scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-3 mb-6 right-input",
    attrs: {
      "slot": "activator",
      "label": "До:",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.untilRu),
      callback: function($$v) {
        _vm.untilRu = $$v
      },
      expression: "untilRu"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autoclose": "",
      "locale": 'ru-RU'
    },
    model: {
      value: (_vm.until),
      callback: function($$v) {
        _vm.until = $$v
      },
      expression: "until"
    }
  })], 1) : _vm._e(), _vm._v("\n         "), (_vm.showFilters()) ? _c('v-text-field', {
    staticClass: "mt-3 mb-6 right-input",
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "type": "time"
    },
    model: {
      value: (_vm.untilTime),
      callback: function($$v) {
        _vm.untilTime = $$v
      },
      expression: "untilTime"
    }
  }) : _vm._e(), _vm._v("\n            \n      "), (_vm.showFilters() && _vm.$route.path != '/orders') ? _c('v-select', {
    staticClass: "mt-3 mb-6 select-box",
    staticStyle: {
      "max-width": "130px"
    },
    attrs: {
      "items": _vm.workers,
      "label": "Сотрудник",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(workers) {
        return [_vm._v("\n          " + _vm._s(workers.item.nick_name) + " \n        ")]
      }
    }, {
      key: "item",
      fn: function(workers) {
        return [_vm._v("\n          " + _vm._s(workers.item.nick_name) + " \n        ")]
      }
    }]),
    model: {
      value: (_vm.worker),
      callback: function($$v) {
        _vm.worker = $$v
      },
      expression: "worker"
    }
  }) : _vm._e(), _vm._v("\n          \n      "), (_vm.$route.path === '/pdfchecks') ? _c('v-select', {
    staticClass: "mt-3 mb-6 select-box",
    attrs: {
      "items": _vm.banks,
      "label": "Банк",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(banks) {
        return [_vm._v("\n          " + _vm._s(banks.item.name) + " \n        ")]
      }
    }, {
      key: "item",
      fn: function(banks) {
        return [_vm._v("\n          " + _vm._s(banks.item.name) + " \n        ")]
      }
    }]),
    model: {
      value: (_vm.bank),
      callback: function($$v) {
        _vm.bank = $$v
      },
      expression: "bank"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/orders') ? _c('v-select', {
    staticClass: "mt-3 mb-6 select-box",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "items": _vm.accounts,
      "label": "Аккаунт",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(accounts) {
        return [_vm._v("\n          " + _vm._s(accounts.item.account_name) + " \n        ")]
      }
    }, {
      key: "item",
      fn: function(accounts) {
        return [_vm._v("\n          " + _vm._s(accounts.item.account_name) + " \n        ")]
      }
    }]),
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('span', {
    staticStyle: {
      "margin-left": "0.4rem"
    }
  }, [_vm._v("Оплачено до: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "0.4rem",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.account_info.paid_until) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.account_info.paid_count > -2) ? _c('span', {
    staticStyle: {
      "margin-left": "0.4rem"
    }
  }, [_vm._v("Остаток проверок: ")]) : _vm._e(), _vm._v(" "), (_vm.account_info.paid_count < -1) ? _c('span', {
    staticStyle: {
      "margin-left": "0.4rem"
    }
  }, [_vm._v("Оплачено аккаунтов: ")]) : _vm._e(), _vm._v(" "), (_vm.account_info.paid_count > -1) ? _c('span', {
    staticStyle: {
      "margin-left": "0.4rem",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.account_info.paid_count) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account_info.paid_count == -1) ? _c('span', {
    staticStyle: {
      "margin-left": "0.4rem",
      "font-size": "18px"
    }
  }, [_vm._v("∞")]) : _vm._e(), _vm._v(" "), (_vm.account_info.paid_count < -1) ? _c('span', {
    staticStyle: {
      "margin-left": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.account_info.paid_count * -1))]) : _vm._e()])])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.darkMode()
      }
    }
  }, [_c('v-icon', [_vm._v("wb_sunny")])], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', {
    attrs: {
      "dark": _vm.dark
    }
  })], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticStyle: {
      "justify-content": "center",
      "text-align": "center"
    },
    attrs: {
      "inset": true,
      "app": ""
    }
  }, [_c('span', [_vm._v("© BankPDF-CRM 2025")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-1062a6bc","hasScoped":true}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 412
// module chunks = 0